import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HomeComponent } from './website/home/home.component';
import { WorkComponent } from './website/work/work.component';
import { AppRoutingModule } from './app-routing.module';
import { Router } from '@angular/router';
import { WebsiteModule } from './website/website.module';
import { WebsiteRoutingModule } from './website/website-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastModule } from 'primeng/toast';
import { LayoutComponent } from './website/layout/layout.component';
import { FooterComponent } from './website/footer/footer.component';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    FooterComponent
  ],
  imports: [
    WebsiteModule,
    AppRoutingModule,
    BrowserModule,
    WebsiteRoutingModule,
    BrowserAnimationsModule,
    ToastModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor(router: Router){

  }
}
